import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'vds-teaser-solutions-item',
  styleUrl: 'vds-teaser-solutions-item.scss',
  shadow: true,
})
export class VdsTeaserSolutionsItem {

  /**
   * Headline
   * Mandatory: no
   * Max. 200 chars
   */
   @Prop() headline: string;

   /**
    * Copy
    * Mandatory: yes
    * Max. 80 chars
    */
   @Prop() copy: string;

   /**
    * Controls the visibility of the icon slot
    */
   @Prop() showIcon: boolean = true;

   /**
    * Sets alignment of content
    */
   @Prop() alignment: 'center' | 'left' = 'center';

   /**
   * Controls the whitespace arround content
   */
  @Prop() spacing: 'default' | 'narrow' = 'default';

   render() {
    const { headline, copy, showIcon, alignment, spacing } = this;

     return (
      <Host>
        <div class="relative flex flex-col justify-around bg-white border-2 border-grey-lighter border-b-8 border-b-yellow rounded-[5px] pb-[50px] transition duration-300 hover:bg-white hover:shadow-[0_14px_25px_rgba(0,0,0,0.16)] hover:scale-[1.02] hover:cursor-pointer h-full">

          { showIcon && (
            <div class="flex justify-center overflow-hidden">
              <slot name="icon"></slot>
            </div>
          )}

          <div class="flex-1 flex flex-col justify-between">
            <div class={{
              "px-[20px] sm:px-[30px] pb-[30px]": true,
              "pt-6": !showIcon && spacing === "default",
              "pt-8": spacing === "narrow"
            }}>
              <h3 innerHTML={headline} class={{
                "flex items-center font-heavy text-h3-mobile sm:text-h3-tablet lg:text-h3-desktop uppercase break-words": true,
                "justify-center text-center": alignment === 'center',
                "justify-start text-left": alignment === 'left',
                "min-h-[64px] mb-[40px]": spacing === "default",
                "mb-[25px]": spacing === "narrow"
              }}>
              </h3>
              <p class="text-grey-dark text-sidebar-mobile sm:text-sidebar-desktop">{copy}</p>
            </div>
            <div class={{
              "px-[20px] sm:px-[30px]": true,
              "text-center": alignment === 'center',
              "text-left": alignment === 'left',
              "pt-0": spacing === "narrow",
              "md:pt-[30px] md:pb-[20px]": spacing === "default",
            }}>
              <slot name="cta"></slot>
            </div>
          </div>

        </div>
      </Host>
     );
   }

}
